import { render, staticRenderFns } from "./header_culinarymobile.vue?vue&type=template&id=32690d90&"
import script from "./header_culinarymobile.vue?vue&type=script&lang=js&"
export * from "./header_culinarymobile.vue?vue&type=script&lang=js&"
import style0 from "./header_culinarymobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports